import {Button} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {PullRequestReviewInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {DockedPanel, useDockedPanelActions} from '../../../../contexts/DockedPanelContext'

export function PullRequestReviewAction({info}: {info: PullRequestReviewInfo}) {
  const dockedPanelActions = useDockedPanelActions()
  const {reviewId, commentCount} = info

  if (!commentCount || !reviewId) {
    return null
  }
  return (
    <Button
      onClick={() =>
        dockedPanelActions.openPanel(DockedPanel.Comments, {
          metadata: {filterText: `review-id:${reviewId}`, viewMode: 'review-comments'},
        })
      }
      size="small"
      variant="invisible"
      aria-label={`View ${commentCount} review comment${commentCount === 1 ? '' : 's'}`}
      leadingVisual={CommentIcon}
      className="flex-items-center"
    >
      {commentCount}
    </Button>
  )
}
